import { parsePhoneNumber, getCountryCallingCode, CountryCode } from 'libphonenumber-js';

// Checkout Forms
import { PHONE_NUMBER } from 'checkout-forms/form/fields';

// Config
import { phoneNumberRegex } from '@utils/address/addressHelpers';

export function getCountryCode(number: string, countryCode: CountryCode) {
  const isDomesticFormat = number && !number.match(/^(00[1-9]+)|(\+[1-9]+)/);
  return number && isDomesticFormat ? 'GB' : countryCode;
}

export function getCallingCode(countryCode: CountryCode) {
  try {
    return getCountryCallingCode(countryCode);
  } catch {
    return '';
  }
}

export function parseInitialPhoneNumber(value: string, defaultCountryCode: CountryCode) {
  const countryCode = getCountryCode(value, defaultCountryCode);

  try {
    const phoneNumber = parsePhoneNumber(value, countryCode);

    return {
      countryCode: phoneNumber.country || countryCode,
      number: phoneNumber.nationalNumber,
      value: phoneNumber.number,
      isValid: phoneNumber.isValid(),
    };
  } catch {
    const code = getCallingCode(countryCode);
    const regex = new RegExp(`^((\\+(${code})?)|(00(${code})?))`);
    const number = value.replace(regex, '');

    return {
      countryCode,
      number,
      value,
      isValid: false,
      error: true,
    };
  }
}

export function parseInputPhoneNumber(number: string, countryCode: CountryCode | 'other') {
  if (countryCode === 'other') {
    return {
      value: number,
      isValid: true,
    };
  }

  try {
    const phoneNumber = parsePhoneNumber(number, countryCode);

    return {
      value: phoneNumber.number,
      isValid: phoneNumber.isValid(),
    };
  } catch {
    const code = getCallingCode(countryCode);

    return {
      value: number ? `+${code}${number}` : '',
      isValid: false,
    };
  }
}

function getInternationalPhoneNumberBaseConfig({
  instruction,
  isClickCollectOrder,
  showDefaultInstruction,
}: {
  instruction?: string;
  isClickCollectOrder?: boolean;
  showDefaultInstruction?: boolean;
} = {}) {
  let fieldInstruction;

  if (instruction) {
    fieldInstruction = instruction;
  } else if (showDefaultInstruction) {
    if (isClickCollectOrder) {
      fieldInstruction = 'We’ll use this number to send text updates or if we have any queries with your order';
    } else {
      fieldInstruction = 'We’ll use this number if we have any queries with your payment';
    }
  }

  return {
    ...PHONE_NUMBER,
    ...(fieldInstruction && { instruction: fieldInstruction }),
    regex: phoneNumberRegex,
    required: true,
  };
}

export default function getInternationalPhoneNumberConfig(
  options: {
    instruction?: string;
    isClickCollectOrder?: boolean;
    showDefaultInstruction?: boolean;
  } = {},
) {
  return getInternationalPhoneNumberBaseConfig(options);
}
